import { render } from "./TermsConditionsPage.vue?vue&type=template&id=28c1e1a9"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=js"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__